/**
 * Liste LLM $/dk (katalog, ×1.5 dahil ham oran) → müşteriye yansıyan $/dk.
 * AgentEditor üst metrik ile aynı formül.
 *
 * @param {number} rawListUsdPerMin
 * @param {number} aiUsageCommissionPercent — örn. site.aiUsageCommission
 * @returns {number}
 */
export function customerLlmUsdPerMinuteFromList(rawListUsdPerMin, aiUsageCommissionPercent) {
    var raw = Number(rawListUsdPerMin);
    if (!raw || isNaN(raw)) {
        return 0;
    }
    var stableCommissionRate = 1.2;
    var aiCallCommissionRate = Math.max(Number(aiUsageCommissionPercent) / 100, 0);
    var totalCommissionRate = stableCommissionRate + aiCallCommissionRate;
    var stableLlmPrice = raw * stableCommissionRate;
    var totalLlmPrice = raw * totalCommissionRate;
    return Math.max(totalLlmPrice, stableLlmPrice);
}

/** Retell bileşen bazlı ham fiyatlar (×1.5 uygulanmamış) — retellai.com/pricing */
export var RETELL_BASE_PRICES = {
    voiceInfra: 0.055,
    knowledgeBase: 0.005,
    telephonySip: 0,
    telephonyTwilio: 0.015,
    tts: {
        elevenlabs: 0.04,
        elevenlabs_v3: 0.2,
        elevenlabs_multilingual_v2: 0.06,
        cartesia: 0.015,
        openai: 0.015,
        retell: 0.015,
        minimax: 0.015,
        fish: 0.015,
    },
};

/** Retell liste fiyatına uygulanan standart çarpan */
export var RETELL_LIST_MULTIPLIER = 1.5;

/** ElevenLabs ses modeli → Retell TTS ham $/dk eşlemesi */
var ELEVENLABS_VOICE_MODEL_USD_PER_MINUTE = {
    eleven_turbo_v2_5: RETELL_BASE_PRICES.tts.elevenlabs,
    eleven_flash_v2_5: RETELL_BASE_PRICES.tts.elevenlabs,
    eleven_multilingual_v2: RETELL_BASE_PRICES.tts.elevenlabs_multilingual_v2,
    eleven_v3: RETELL_BASE_PRICES.tts.elevenlabs_v3,
};

/**
 * ElevenLabs TTS ham $/dk (Retell fiyatı, ×1.5 yok)
 * @param {string} [voiceModelId] agent.voice_model
 * @returns {number}
 */
export function getElevenLabsVoiceModelUsdPerMinute(voiceModelId) {
    if (!voiceModelId) {
        return ELEVENLABS_VOICE_MODEL_USD_PER_MINUTE.eleven_multilingual_v2;
    }
    var id = String(voiceModelId).trim();
    if (Object.prototype.hasOwnProperty.call(ELEVENLABS_VOICE_MODEL_USD_PER_MINUTE, id)) {
        return ELEVENLABS_VOICE_MODEL_USD_PER_MINUTE[id];
    }
    return ELEVENLABS_VOICE_MODEL_USD_PER_MINUTE.eleven_multilingual_v2;
}
